{
  "familyId": "SPR-KLANK-VERDUBBEL",
  "questions": [
    {
      "id": "SPR-KLANK-VERDUBBEL-001",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "multiple_choice",
      "question": "Wat is de juiste spelling? De ... zit op het dak.",
      "options": ["kat-ten → katten", "ka-ten → katen", "kat-en → katen", "ka-tten → katten"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "katten",
            "syllables": ["kat", "ten"],
            "types": ["closed", "closed"],
            "highlight": [1],
            "label": "kat·ten — de t wordt verdubbeld"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Medeklinker verdubbelen",
            "content": "Bij een korte klank in een open lettergreep verdubbel je de medeklinker. 'Kat' heeft een korte 'a'. In het meervoud: kat → kat-ten (de t wordt verdubbeld om de klank kort te houden).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "consonant_doubling_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Kat' heeft een korte 'a'. In het meervoud wordt de 't' verdubbeld: kat-ten → katten. Zonder verdubbeling zou het 'ka-ten' worden, en dan klinkt de 'a' lang (zoals in 'laten'). De verdubbeling houdt de klank kort.",
        "solutionSteps": [
          "'Kat' heeft een korte klank: a",
          "Meervoud: voeg -en toe",
          "Verdubbel de medeklinker: kat → kat-ten",
          "Schrijf: katten"
        ],
        "distractorExplanations": {
          "0": "Goed! De t wordt verdubbeld om de korte klank te behouden: katten.",
          "1": "Zonder verdubbeling wordt het 'ka-ten', en dan klinkt de 'a' lang (zoals in 'laten'). De verdubbeling houdt de klank kort. Onthoud: korte klank → medeklinker verdubbelen.",
          "2": "De verdeling 'kat-en' klopt niet — je moet de medeklinker verdubbelen: 'kat-ten'. Onthoud: bij een korte klank verdubbel je de medeklinker vóór de uitgang.",
          "3": "De verdeling 'ka-tten' klopt niet — de dubbele medeklinker hoort bij de eerste lettergreep: 'kat-ten', niet 'ka-tten'. Onthoud: de eerste lettergreep eindigt op de dubbele medeklinker."
        }
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-002",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "multiple_choice",
      "question": "Welk woord is FOUT gespeld?",
      "options": ["bommen (van bom)", "netten (van net)", "pennen (van pen)", "boten (van bot)"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Medeklinker verdubbelen",
            "content": "'Bot' heeft een korte 'o'. In het meervoud moet de 't' verdubbeld worden: bot-ten → botten. 'Boten' (zonder verdubbeling) klinkt als 'bo-ten' met een lange 'o' (zoals in 'boten' = schepen).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "consonant_doubling_error_detect",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Boten' is fout als meervoud van 'bot' (been). Het moet 'botten' zijn (met dubbele t). 'Boten' zonder verdubbeling betekent iets anders: schepen! Bommen, netten en pennen zijn correct gespeld.",
        "solutionSteps": [
          "'Bot' heeft een korte 'o'",
          "Meervoud: bot → bot-ten → botten",
          "'Boten' (zonder verdubbeling) = schepen (ander woord!)",
          "De andere woorden zijn correct: bommen, netten, pennen"
        ],
        "distractorExplanations": {
          "0": "'Bommen' is correct: bom → bom-men → bommen. De 'm' wordt verdubbeld om de korte 'o' te behouden.",
          "1": "'Netten' is correct: net → net-ten → netten. De 't' wordt verdubbeld om de korte 'e' te behouden.",
          "2": "'Pennen' is correct: pen → pen-nen → pennen. De 'n' wordt verdubbeld om de korte 'e' te behouden.",
          "3": "Goed! 'Boten' is fout als meervoud van 'bot'. Het moet 'botten' zijn."
        }
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-003",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je het meervoud van 'kop'?",
      "options": ["kopen", "koopen", "koppen", "kopppen"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "koppen",
            "syllables": ["kop", "pen"],
            "types": ["closed", "closed"],
            "highlight": [1],
            "label": "kop·pen — de p wordt verdubbeld"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Korte klank → verdubbelen",
            "content": "'Kop' heeft een korte 'o'. Zonder verdubbeling wordt het 'ko-pen' (lange 'o', zoals in 'kopen' = iets aanschaffen). Met verdubbeling: kop-pen → koppen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "consonant_doubling_kop",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Kop' heeft een korte 'o'. Verdubbel de 'p': kop-pen → koppen. Zonder verdubbeling wordt het 'kopen' — en dat is een heel ander woord (iets aanschaffen)!",
        "solutionSteps": [
          "'Kop' heeft een korte klank: o",
          "Verdubbel de medeklinker: p → pp",
          "kop-pen → koppen",
          "Check: 'kopen' (zonder verdubbeling) = iets aanschaffen ≠ meervoud van kop"
        ],
        "distractorExplanations": {
          "0": "'Kopen' zonder verdubbeling betekent 'iets aanschaffen' — een heel ander woord! Het meervoud van 'kop' is 'koppen'. Onthoud: korte klank → verdubbelen.",
          "1": "Je dacht waarschijnlijk dat je de klinker verdubbelt: 'koopen'. Maar bij een korte klank verdubbel je de medeklinker, niet de klinker. 'oo' maakt de klank juist lang. Onthoud: korte klank → dubbele medeklinker.",
          "2": "Goed! De p wordt verdubbeld: koppen.",
          "3": "Je verdubbelt de medeklinker maar één keer: 'pp', niet 'ppp'. Onthoud: verdubbeling = twee keer dezelfde letter."
        }
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-004",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "multiple_choice",
      "question": "Bij welk woord hoef je de medeklinker NIET te verdubbelen in het meervoud?",
      "options": ["kat → katten", "boom → bomen", "bom → bommen", "bed → bedden"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lange klank → geen verdubbeling",
            "content": "'Boom' heeft al een lange klank (oo). Bij een lange klank hoef je de medeklinker niet te verdubbelen. Het meervoud is gewoon 'bo-men' → bomen. Bij korte klanken (kat, bom, bed) moet je wél verdubbelen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "consonant_doubling_exception_long",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Boom' heeft een lange klank (oo). Bij lange klanken hoef je de medeklinker niet te verdubbelen: boom → bo-men → bomen. Bij korte klanken (kat, bom, bed) moet je wél verdubbelen om de klank kort te houden.",
        "solutionSteps": [
          "'Boom' heeft een lange klank: oo",
          "Lange klank → geen verdubbeling nodig",
          "boom → bo-men → bomen",
          "Korte klanken (kat, bom, bed) → wél verdubbelen"
        ],
        "distractorExplanations": {
          "0": "'Kat' heeft een korte 'a' → wél verdubbelen: katten. Onthoud: korte klank = verdubbelen.",
          "1": "Goed! 'Boom' heeft een lange klank → geen verdubbeling: bomen.",
          "2": "'Bom' heeft een korte 'o' → wél verdubbelen: bommen. Onthoud: korte klank = verdubbelen.",
          "3": "'Bed' heeft een korte 'e' → wél verdubbelen: bedden. Onthoud: korte klank = verdubbelen."
        }
      }
    },
    {
      "id": "SPR-KLANK-VERDUBBEL-005",
      "familyId": "SPR-KLANK-VERDUBBEL",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_medeklinker_verdubbel",
      "questionType": "fill_in",
      "question": "Schrijf het meervoud van 'bal'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["ballen"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Medeklinker verdubbelen",
            "content": "'Bal' heeft een korte 'a'. Verdubbel de 'l': bal → bal-len → ballen. Zonder verdubbeling wordt het 'ba-len' (= boos zijn), een heel ander woord!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "consonant_doubling_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Bal' heeft een korte 'a'. Verdubbel de 'l': bal-len → ballen. Zonder verdubbeling wordt het 'balen' (= boos zijn)!",
        "solutionSteps": [
          "'Bal' heeft een korte klank: a",
          "Verdubbel de medeklinker: l → ll",
          "bal-len → ballen"
        ]
      }
    }
  ]
}